const DefaultPalette = (mode, skin, themeColor) => {
  // ** Vars
  const lightColorHex = '#3A3541'
  const darkColorHex = '#E7E3FC'
  const lightColorRgb = '58, 53, 65'
  const darkColorRgb = '231, 227, 252'
  const mainColorRgb = mode === 'light' ? lightColorRgb : darkColorRgb
  const mainColorHex = mode === 'light' ? lightColorHex : darkColorHex

  const primaryGradient = () => {
    if (themeColor === 'primary') {
      return '#FC9155'
    } else if (themeColor === 'secondary') {
      return '#024FAA'
    } else if (themeColor === 'success') {
      return '#FC9155'
    } else if (themeColor === 'error') {
      return '#FC9155'
    } else if (themeColor === 'warning') {
      return '#FC9155'
    } else {
      return '#FC9155'
    }
  }

  const defaultBgColor = () => {
    if (skin === 'bordered' && mode === 'light') {
      return '#FFF'
    } else if (skin === 'bordered' && mode === 'dark') {
      return '#312D4B'
    } else if (mode === 'light') {
      return '#F4F5FA'
    } else return '#28243D'
  }

  return {
    customColors: {
      dark: darkColorHex,
      main: mainColorHex,
      light: lightColorHex,
      darkBg: '#28243D',
      lightBg: '#F4F5FA',
      primaryGradient: primaryGradient(),
      bodyBg: mode === 'light' ? '#FC9155' : '#FC9155',
      tableHeaderBg: mode === 'light' ? '#F9FAFC' : '#3D3759'
    },
    common: {
      black: '#000',
      white: '#FFF'
    },
    mode: mode,
    primary: {
      light: '#9E69FD',//
      main: '#FC9155',
      dark: '#FC9155',
      contrastText: '#FFF'
    },
    secondary: {
      light: '#024FAA',
      main: '#8A8D93',
      dark: '#777B82',
      contrastText: '#FFF'
    },
    success: {
      light: '#6AD01F',
      main: '#56CA00',
      dark: '#4CB200',
      contrastText: '#FFF'
    },
    error: {
      light: '#FF6166',
      main: '#FF4C51',
      dark: '#E04347',
      contrastText: '#FFF'
    },
    warning: {
      light: '#FFCA64',
      main: '#FFB400',
      dark: '#E09E00',
      contrastText: '#FFF'
    },
    info: {
      light: '#32BAFF',
      main: '#16B1FF',
      dark: '#139CE0',
      contrastText: '#FFF'
    },
    grey: {
      50: '#FAFAFA',
      100: '#F5F5F5',
      200: '#EEEEEE',
      300: '#E0E0E0',
      400: '#BDBDBD',
      500: '#9E9E9E',
      600: '#757575',
      700: '#616161',
      800: '#424242',
      900: '#212121',
      A100: '#D5D5D5',
      A200: '#AAAAAA',
      A400: '#616161',
      A700: '#303030'
    },
    text: {
      primary: `rgba(${mainColorRgb}, 0.87)`,
      secondary: `rgba(${mainColorRgb}, 0.68)`,
      disabled: `rgba(${mainColorRgb}, 0.38)`
    },
    divider: `rgba(${mainColorRgb}, 0.12)`,
    background: {
      paper: mode === 'light' ? '#FFF' : '#00000',
      default: defaultBgColor()
    },
    action: {
      active: `rgba(${mainColorRgb}, 0.54)`,
      hover: `rgba(${mainColorRgb}, 0.04)`,
      selected: `rgba(${mainColorRgb}, 0.08)`,
      disabled: `rgba(${mainColorRgb}, 0.3)`,
      disabledBackground: `rgba(${mainColorRgb}, 0.18)`,
      focus: `rgba(${mainColorRgb}, 0.12)`
    }
  }
}

export default DefaultPalette
